var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isChile)?_c('chile-reqs',_vm._b({},'chile-reqs',_vm.bindReqsData,false)):(_vm.isPeru)?_c('peru-reqs',_vm._b({},'peru-reqs',_vm.bindReqsData,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }